import {useUpmPlantNow} from '@hconnect/upm'
import {TextField} from '@mui/material'
import {LocalizationProvider, DateTimePicker} from '@mui/x-date-pickers'
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment'
import {Moment} from 'moment-timezone'

interface OptimizerSettingsDateTimePickerProps {
  label: string
  errorMessage?: string
  value: Moment
  setValue?: (value: Moment | null) => void
  'data-test-id'?: string
}

export const OptimizerSettingsDateTimePicker: React.FC<OptimizerSettingsDateTimePickerProps> = ({
  label,
  errorMessage,
  value,
  setValue,
  'data-test-id': testId
}) => {
  const getPlantNow = useUpmPlantNow()

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DateTimePicker
        label={label}
        value={value}
        views={['year', 'month', 'day', 'hours']}
        readOnly={!setValue}
        disableOpenPicker={!setValue}
        disablePast
        onChange={(value) => {
          setValue && setValue(value !== null ? value.clone().minute(0) : getPlantNow().minute(0))
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="filled"
            size="small"
            error={!!errorMessage}
            helperText={errorMessage}
            sx={({spacing}) => ({
              width: spacing(30),
              backgroundColor: 'transparent',
              '& .MuiFilledInput-root': {
                backgroundColor: 'transparent',
                height: spacing(6),
                borderRadius: spacing(0.5),
                ...(!setValue ? {border: 'none'} : {})
              },
              '& .MuiFilledInput-root:hover': {
                backgroundColor: 'transparent'
              }
            })}
            data-test-id={testId}
          />
        )}
      />
    </LocalizationProvider>
  )
}
